/*
 * @Author: Marte
 * @Date:   2017-10-26 10:00:39
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-11-28 16:52:39
 */
'use strict';
angular.module('subscribeSourceCtrlModule', ['channelPaginationModule']).controller('subscribeSourceCtrl', [
    '$scope',
    'trsspliceString',
    '$validation',
    'modalDialog',
    '$timeout',
    'trsHttpService',
    '$modalInstance',
    'folder',
    '$q',
    'resourceCenterService',
    function($scope, trsspliceString, $validation, modalDialog, $timeout, trsHttpService, $modalInstance, folder, $q, resourceCenterService) {
        /**
         * [close description] 初始化数据
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                channelList: [
                    {
                        name: '网站栏目',
                        ename: 'wz',
                    },
                    {
                        name: 'APP栏目',
                        ename: 'app',
                    },
                    {
                        name: '微信公众号',
                        ename: 'wx',
                    },
                    {
                        name: '集团成品库',
                        ename: 'jtcpg',
                    },
                    {
                        name: '数字报刊',
                        ename: 'szb',
                    },
                    {
                        name: '新华社线路',
                        ename: 'xhsg',
                    },
                ],
                channelNumLimit: 10000, //订阅栏目数量限制
                deleteGroups: [],
                isSearchAll: false,
                isPushMsg: '1', //设置是否更新推送消息
            };
            $scope.data = {
                conditions: [
                    { name: '开启', value: '1' },
                    { name: '关闭', value: '0' },
                ],
            };
            $scope.filterWay('sourceFilter');
        }

        /**
         * [initData description]  初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getScribeInfo();
        }

        /**
          * [addGroup 新增条件分组]
          *
          * @return  {[type]}  [return description]
          */
        $scope.addGroup = function() {
            var deffer = $q.defer();
            $scope.data.scribeInfo.unshift({
                id: 0,
                cs: [],
                fs: [],
                as: [],
                asdetail: [],
                ms: [],
                ks: [],
                ps: [],
            });
            $scope.selectGroup($scope.data.scribeInfo[0]).then(function() {
                deffer.resolve();
            });
            return deffer.promise;
        };

        /**
         * [resourceIsSelected description] 来源是否被选中
         * @param  {[type]} item [description] 被校验的来源
         * @return {[type]}      [description]
         */
        $scope.resourceIsSelected = function(item) {
            var flag = {
                flag: false,
                disabled: false,
                class: '',
            };
            if (!$scope.status.selectedGroup) {
                return flag;
            }
            for (var i = 0; i < $scope.status.selectedGroup.cs.length; i++) {
                var resource = $scope.status.selectedGroup.cs[i];
                if (resource.id === item.HYBASEID) {
                    flag = {
                        flag: true,
                        index: i,
                        disabled: false,
                        class: 'on',
                    };
                    return flag;
                }
            }
            for (var j in $scope.data.scribeInfo) {
                var item_ = $scope.data.scribeInfo[j];
                for (var k in item_.cs) {
                    var item__ = item_.cs[k];
                    if (item__.id === item.HYBASEID) {
                        flag.disabled = true;
                        flag.class = 'disabled';
                    }
                }
            }
            return flag;
        };

        /**
          * [selectResource 选中来源]
          *
          * @param   {[type]}  resource  [resource 被选来源]
          * @param   {[type]}  success   [success description]
          *
          * @return  {[type]}            [return description]
          */
        $scope.selectResource = function(resource, success) {
            var flag = $scope.resourceIsSelected(resource); //flag为true表示已经被选中了
            if (flag.disabled) return;
            hasSelectedGroup().then(function() {
                $timeout(function() {
                    if (flag.flag) {
                        $scope.status.selectedGroup.cs.splice(flag.index, 1);
                    } else {
                        if (isChannelNumTooMuch().flag) return;
                        $scope.status.selectedGroup.cs.unshift({
                            id: resource.HYBASEID,
                            name: resource.SOURCENAME + ' | ' + resource.CHANNEL,
                            sourceChannel: $scope.status.selectedChannel.ename,
                        });
                    }
                    if (typeof success === 'function') success();
                });
            });
        };

        /**
         * [isChannelNumTooMuch description] 订阅栏目总数量是否过多
         * @return {Boolean} [description]
         */
        function isChannelNumTooMuch() {
            var num = 0;
            for (var i in $scope.data.scribeInfo) {
                num += $scope.data.scribeInfo[i].cs.length;
            }
            if (num >= $scope.status.channelNumLimit) {
                modalDialog.alertType(
                    '订阅栏目总数已经达到订阅栏目数量上限（' + $scope.status.channelNumLimit + '个），不能再添加了！',
                    '',
                    'warning',
                    'confirm'
                );
                return { flag: true, num: num };
            }
            return { flag: false, num: num };
        }

        /**
         * [selectGroup description] 选中分组
         * @param  {[object]} group [description] 被选分组
         * @return {[type]}       [description]
         */
        $scope.selectGroup = function(group) {
            var deffer = $q.defer();
            delete $scope.status.selectedGroup;
            $timeout(function() {
                $scope.status.selectedGroup = group;
                for (var i = 0; i < $scope.data.scribeInfo.length; i++) {
                    //聚焦
                    if ($scope.data.scribeInfo[i] === group) {
                        $('#focus_' + i)[0].focus();
                    }
                }
                deffer.resolve();
            }, 10);
            return deffer.promise;
        };

        /**
         * [selectGroup description] 删除分组
         * @param  {[int]} index [description] 序号
         * @param {object} [$event] [description] 点击事件
         * @return {[type]} [description]
         */
        $scope.deleteGroup = function(index, $event) {
            $event.stopPropagation();
            groupIsEmpty($scope.data.scribeInfo[index]).then(function() {
                if ($scope.data.scribeInfo[index].id != 0) {
                    $scope.status.deleteGroups.push($scope.data.scribeInfo[index].id);
                }
                if ($scope.data.scribeInfo.length === 1) {
                    $scope.data.scribeInfo.splice(0, 1);
                    delete $scope.status.selectedGroup;
                    return;
                }
                if (index === 0) {
                    $scope.selectGroup($scope.data.scribeInfo[1]);
                } else {
                    $scope.selectGroup($scope.data.scribeInfo[index - 1]);
                }
                $scope.data.scribeInfo.splice(index, 1);
            });
        };

        /**
         * [groupIsEmpty description] 判断订阅栏中是否是空的
         * @param {object} [group] [description] 订阅栏数据
         * @return {[boolean]} [description] true为是空的 false表示有内容
         */
        function groupIsEmpty(group) {
            var defer = $q.defer();
            var flag = true;
            for (var i in group) {
                if (group[i] instanceof Array && group[i].length > 0) {
                    flag = false;
                    break;
                }
            }
            if (flag) {
                defer.resolve();
            } else {
                modalDialog.alertType('删除后会丢失已订阅内容，确定要删除么？', '', 'ask', true, function() {
                    defer.resolve();
                });
            }
            return defer.promise;
        }

        /**
         * [selectTheme description] 选择主题
         * @param  {[type]} item [description] 被选主题
         * @return {[type]}      [description]
         */
        $scope.selectTheme = function(item) {
            hasSelectedGroup().then(function() {
                var flag = $scope.themeIsSelected(item); //flag为true表示已经被选中了
                if (flag.flag) {
                    $scope.status.selectedGroup.fs.splice(flag.index, 1);
                } else {
                    $scope.status.selectedGroup.fs.unshift({
                        id: item.id,
                        name: item.dictName,
                    });
                }
            });
        };

        /**
         * [themeIsSelected description] 主题是否已经被选中
         * @param  {[type]} item [description] 被校验主题
         * @return {[type]}      [description]
         */
        $scope.themeIsSelected = function(item) {
            var flag = {
                flag: false,
            };
            if (!$scope.status.selectedGroup) {
                return flag;
            }
            for (var i = 0; i < $scope.status.selectedGroup.fs.length; i++) {
                var theme = $scope.status.selectedGroup.fs[i];
                if (theme.id === item.id) {
                    flag = {
                        flag: true,
                        index: i,
                    };
                    return flag;
                }
            }
            return flag;
        };

        /**
         * [removeThemeFromGroup description] 从分组中删除主题
         * @param  {[type]} index [description] 序号
         * @return {[type]}       [description]
         */
        $scope.removeThemeFromGroup = function(index) {
            $scope.status.selectedGroup.fs.splice(index, 1);
        };

        /**
         * [mediaIsSelected description] 媒体是否被选中
         * @param  {[type]} type [description] 媒体类型
         * @return {[type]}      [description]
         */
        $scope.mediaIsSelected = function(type) {
            if (!$scope.status.selectedGroup) {
                return false;
            }
            if ($scope.status.selectedGroup.ms.length && $scope.status.selectedGroup.ms[0][type] === 1) {
                return true;
            }
            return false;
        };

        /**
         * [selectedMedia description] 选中媒体
         * @param  {[type]} type [description] 媒体类型
         * @return {[type]} [description]
         */
        $scope.selectedMedia = function(type) {
            hasSelectedGroup().then(function() {
                if ($scope.status.selectedGroup.ms.length === 0) {
                    $scope.status.selectedGroup.ms[0] = { image: 0, media: 0 };
                }
                var value = $scope.status.selectedGroup.ms[0][type];
                $scope.status.selectedGroup.ms[0][type] = value === 0 ? 1 : 0;
                if ($scope.status.selectedGroup.ms[0].image === 0 && $scope.status.selectedGroup.ms[0].media === 0) {
                    $scope.status.selectedGroup.ms = [];
                }
            });
        };

        /**
         * [removeMediaFromGroup description] 从分组中移除媒体
         * @param  {[type]} type [description] 媒体类型
         * @return {[type]} [description]
         */
        $scope.removeMediaFromGroup = function(type) {
            $scope.status.selectedGroup.ms[0][type] = 0;
            if ($scope.status.selectedGroup.ms[0].image === 0 && $scope.status.selectedGroup.ms[0].media === 0) {
                $scope.status.selectedGroup.ms = [];
            }
        };

        /**
         * [removePsFromGroup description]移除内容属性添加项
         * @param  {[type]} key [description]内容属性移除的类型
         * @return {[type]}     [description]
         */
        $scope.removePsFromGroup = function(key) {
            $scope.status.selectedGroup.ps[0][key] = 0;
            if (
                $scope.status.selectedGroup.ps[0].original === 0 &&
                $scope.status.selectedGroup.ps[0].front_page === 0 &&
                $scope.status.selectedGroup.ps[0].read === 0
            ) {
                $scope.status.selectedGroup.ps = [];
            }
        };

        /**
         * [keyWordsFocus 关键词聚焦]
          *
          * @param   {[type]}  $event  [$event description]
          *
          * @return  {[type]}          [return description]
          */
        $scope.keyWordsFocus = function($event) {
            hasSelectedGroup().then(function() {
                $($event.target)
                    .unbind('keydown')
                    .bind('keydown', function(e) {
                        if (e.keyCode === 32 || e.keyCode === 13) {
                            if ($scope.status.selectedGroup.ks.indexOf($scope.status.selectedKeyWord) >= 0) {
                                modalDialog.alertType('请勿重复添加关键词', '', 'warning', false);
                                return;
                            }
                            $validation.validate($scope.keywordForm).success(function() {
                                $scope.status.selectedGroup.ks.push($scope.status.selectedKeyWord);
                                $scope.status.selectedKeyWord = '';
                                $scope.keywordForm.$setPristine();
                            });
                        }
                    });
            });
        };

        /**
         * [keyWordsBlur description] 关键词输入框失焦
         * @return {[type]} [description]
         */
        $scope.keyWordsBlur = function() {
            $scope.status.selectedKeyWord = '';
            $scope.keywordForm.$setPristine();
        };

        /**
         * [removeKeyword description] 移除关键子
         * @param  {[type]} item [description] 被移除的关键字
         * @return {[type]}      [description]
         */
        $scope.removeKeyword = function(item) {
            var index = $scope.status.selectedGroup.ks.indexOf(item);
            $scope.status.selectedGroup.ks.splice(index, 1);
        };

        /**
         * [contentAttrSelected description] 内容属性是否被选中
         * @param  {[type]} type [description] 类型
         * @return {[type]}      [description]
         */
        $scope.contentAttrSelected = function(type) {
            if (!$scope.status.selectedGroup) {
                return false;
            }
            if ($scope.status.selectedGroup.ps.length === 0) {
                return false;
            }
            return $scope.status.selectedGroup.ps[0][type] === 1;
        };

        /**
         * [selectContentAttr description] 选中内容属性
         * @param  {[type]} type [description] 类型
         * @return {[type]} [description]
         */
        $scope.selectContentAttr = function(type) {
            hasSelectedGroup().then(function() {
                if ($scope.status.selectedGroup.ps.length === 0) {
                    $scope.status.selectedGroup.ps[0] = {
                        original: 0,
                        front_page: 0,
                        read: 0,
                    };
                }
                var value = $scope.status.selectedGroup.ps[0][type];
                $scope.status.selectedGroup.ps[0][type] = value === 1 ? 0 : 1;
                if (
                    $scope.status.selectedGroup.ps[0].original === 0 &&
                    $scope.status.selectedGroup.ps[0].front_page === 0 &&
                    $scope.status.selectedGroup.ps[0].read === 0
                ) {
                    $scope.status.selectedGroup.ps = [];
                }
            });
        };

        /**
         * [filterWay description] 筛选方式切换
         * @param  {[string]} way [description] 方式
         * @return {[type]}     [description]
         */
        $scope.filterWay = function(way) {
            $scope.status.filterWay = way;
            if (!$scope.status.selectedChannel) {
                $scope.switchChannel($scope.status.channelList[0]);
            }
            if (!$scope.status.conditionType) {
                $scope.getThemeList();
            }
        };

        /**
         * [switchChannel description] 切换来源渠道
         * @param  {[object]} channel [description] 所选渠道
         * @return {[type]} [description]
         */
        $scope.switchChannel = function(channel) {
            $timeout(function() {
                // $scope.status.isSearchAll = false;
                // $scope.status.keyword = "";
                $scope.status.selectedChannel = channel;
                $scope.channelPage = {
                    CURRPAGE: 1,
                    PAGESIZE: 18,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.getSourceList(channel, $scope.status.keyword);
            }, 0);
        };

        /**
          * [getSourceList 获取来源列表]
          *
          * @param   {[type]}  channel  [channel 所选渠道]
          * @param   {[type]}  keyword  [keyword description]
          *
          * @return  {[type]}           [return description]
          */
        $scope.getSourceList = function(channel, keyword) {
            getSourceList(channel, keyword).then(function(data) {
                $scope.status.resourceList = data.content; //来源列表
                $scope.channelPage = data.summary_info;
            });
        };

        /**
          * [getSourceList 获取来源列表]
          *
          * @param   {[type]}  channel  [channel 所选渠道]
          * @param   {[type]}  keyword  [keyword description]
          *
          * @return  {[type]}           [return description]
          */
        function getSourceList(channel, keyword) {
            var deffer = $q.defer();
            var params = {
                typeid: 'zyzx',
                serviceid: 'iwo',
                modelid: 'subscription',
                keyword: keyword ? keyword : '',
                channelName: channel.ename,
                pageNum: $scope.channelPage.CURRPAGE,
                pageSize: $scope.channelPage.PAGESIZE,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
          * [getSuggestionList 获取搜索框建议查询列表]
          *
          * @param   {[type]}  channel  [channel 所选渠道]
          * @param   {[type]}  keyword  [keyword description]
          *
          * @return  {[type]}           [return description]
          */
        function getSuggestionList(channel, keyword) {
            var deffer = $q.defer();
            var params = {
                typeid: 'zyzx',
                serviceid: 'iwo',
                modelid: 'subscription',
                keyword: keyword ? keyword : '',
                channelName: channel.ename,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [searchSource description] 根据关键词搜索来源
         * @param  {[type]} $viewValue [description] 输入诶容
         * @return {[type]}            [description]
         */
        var promise;
        $scope.searchSource = function($viewValue) {
            if (promise) {
                $timeout.cancel(promise);
                promise = null;
            }
            promise = $timeout(function() {
                return getSuggestionList($scope.status.selectedChannel, $viewValue).then(function(data) {
                    for (var i in data.content) {
                        data.content[i].DESC = data.content[i].SOURCENAME + ' | ' + data.content[i].CHANNEL;
                    }
                    return data.content;
                });
            }, 200);
            return promise;
        };
        $scope.$watch('status.keyword', function(newV, oldV) {
            if (angular.isObject(newV)) {
                var flag = $scope.resourceIsSelected(newV);
                if (!flag.flag) $scope.selectResource(newV);
                $scope.status.keyword = '';
            }
        });

        /**
         * [searchAllChanl 回车搜索包含关键字的所有栏目]
         *
         * @param   {[type]}  e  [e description]
         *
         * @return  {[type]}     [return description]
         */
        $scope.searchAllChanl = function(e) {
            var keycode = window.event ? e.keyCode : e.which;
            if (keycode !== 13) return;
            getSourceList($scope.status.selectedChannel, $scope.status.keyword).then(function(data) {
                $scope.status.resourceList = data.content; //来源列表
                $scope.channelPage = data.summary_info;
                $scope.status.isSearchAll = $scope.status.keyword === '' || $scope.status.keyword === undefined ? false : true;
            });
        };

        /**
         * [getAllSearchResults 带搜索结果查全部]
         *
         * @param   {[type]}  channel  [channel description]
         * @param   {[type]}  keyword  [keyword description]
         *
         * @return  {[type]}           [return description]
         */
        function getAllSearchResults(channel, keyword) {
            var deffer = $q.defer();
            var params = {
                typeid: 'zyzx',
                serviceid: 'iwo',
                modelid: 'subscription',
                keyword: keyword ? keyword : '',
                channelName: channel.ename,
                pageNum: 1,
                pageSize: 9999,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getSourceList description] 获取来源列表
         * @param  {[object]} channel [description] 所选渠道
         * @return {[type]} [description]
         */
        $scope.getAllSearchResults = function(channel) {
            getAllSearchResults(channel).then(function(data) {
                $scope.status.resourceList = data.content; //来源列表
                $scope.channelPage = data.summary_info;
            });
        };

        /**
         * [selectAllSearchResule 一键订阅按钮]
         *
         * @param   {[type]}  item  [item description]
         * @param   {[type]}  e     [e description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.selectAllSearchResule = function(item, e) {
            e.stopPropagation();
            if (!$scope.status.isSearchAll) return;
            $scope.loadingPromise = getAllSearchResults($scope.status.selectedChannel, $scope.status.keyword).then(function(data) {
                if (data.content.length <= 0) {
                    modalDialog.alertType('没有符合条件的栏目！', '', 'warning', true);
                    return;
                }
                $scope.status.channelSearchResult = getNerSearchArr(data);
                if ($scope.status.channelSearchResult.length <= 0) {
                    modalDialog.alertType('该关键字搜索的栏目已经全部添加过了！', '', 'warning', 'confirm');
                    return;
                }
                var tooMuchInfo = isChannelNumTooMuch();
                if (tooMuchInfo.flag) {
                    return;
                }
                var different = tooMuchInfo.num + $scope.status.channelSearchResult.length - $scope.status.channelNumLimit; //预选总数和已选总数的和  与 限制数  之间的差
                if (different > 0) {
                    // 差如果大于0 ，则自动缩减预选总数
                    $scope.status.channelSearchResult.splice(0, different);
                }
                var alertInfo =
                    different > 0
                        ? '符合条件的栏目超过订阅栏目数量上限（' +
                          $scope.status.channelNumLimit +
                          '个）,只能再加入' +
                          $scope.status.channelSearchResult.length +
                          '个栏目'
                        : '符合该条件的栏目有' + $scope.status.channelSearchResult.length + '个，确定要全部加入订阅栏？';
                modalDialog.alertType(alertInfo, '', 'ask', true, function() {
                    hasSelectedGroup().then(function() {
                        var array = [];
                        for (var i = 0; i < $scope.status.channelSearchResult.length; i++) {
                            var resource = $scope.status.channelSearchResult[i];
                            array.unshift({
                                id: resource.HYBASEID,
                                name: resource.SOURCENAME + ' | ' + resource.CHANNEL,
                                sourceChannel: $scope.status.selectedChannel.ename,
                            });
                        }
                        $scope.status.selectedGroup.cs = array.concat($scope.status.selectedGroup.cs); //$scope.status.selectedGroup.cs.concat(array);
                        modalDialog.alertType('添加来源成功！', '', 'success', false);
                    });
                });
            });
        };

        /**
         * [getNerSearchArr description]判断搜索结果是否已经被选中
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function getNerSearchArr(data) {
            var list = data.content;
            var newList = [];
            for (var i in list) {
                var flag = $scope.resourceIsSelected(list[i]);
                if (flag.flag == false && flag.disabled == false) {
                    newList.unshift(list[i]);
                }
            }
            return newList;
        }

        /**
         * [getThemeList description] 获取主题列表
         * @return {[type]} [description]
         */
        $scope.getThemeList = function() {
            $scope.status.conditionType = '主题';
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'getAllFields',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.status.themeList = data;
            });
        };

        /**
         * [showSelectedArea description] 数据地域信息的级联菜单获取数据
         * @param  {[type]} node [description] 当前节点
         * @return {[type]}      [description]
         */
        $scope.showSelectedArea = function(node) {
            var deffer = $q.defer();
            resourceCenterService.getArea(node).then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [handleAreaName 地域信息]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.handleAreaName = function(item) {
            return trsspliceString.spliceString(item, 'dictName', '-');
        };

        /**
         * [deleteArea description] 移除地域
         * @param  {[type]} node [description] 当前节点
         * @return {[type]} [description]
         */
        $scope.deleteArea = function(index) {
            $scope.status.selectedGroup.asdetail.splice(index, 1);
        };
        $scope.selectCondition = function(condition) {
            $scope.status.isPushMsg = angular.copy(condition.value);
        };

        /**
         * [confirm description] 确认提交
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            var formData = angular.copy($scope.data.scribeInfo);
            formData = JSON.stringify(handleArea(formData));
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'saveSubscript',
                group_id: folder.id,
                delete_id: $scope.status.deleteGroups.join(','),
                content: formData,
                is_push_msg: $scope.status.isPushMsg,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (data.result === 'success') {
                    modalDialog.alertType('保存成功', '', 'success', false, function() {
                        $modalInstance.close();
                    });
                } else {
                    modalDialog.alertType('保存失败', data.error_info, 'error', 'confirm');
                }
            });
        };

        /**
         * [handleArea 处理地域数据]
         *
         * @param   {[type]}  formData  [formData description]
         *
         * @return  {[type]}            [return description]
         */
        function handleArea(formData) {
            for (var i = 0; i < formData.length; i++) {
                var area = formData[i].asdetail;
                formData[i].as = [];
                for (var j = 0; j < area.length; j++) {
                    var item = area[j];
                    formData[i].as.push({
                        id: item[item.length - 1].id,
                        name: item[item.length - 1].dictName,
                    });
                }
            }
            return formData;
        }

        /**
         * [hasSelectedGroup description] 判断是否已经有选中分组了，没有的话创建并选中一个
         * @return {Boolean} [description]
         */
        function hasSelectedGroup() {
            var deffer = $q.defer();
            if (!$scope.status.selectedGroup) {
                $scope.addGroup().then(function() {
                    deffer.resolve();
                });
            } else {
                deffer.resolve();
            }
            return deffer.promise;
        }
       
        /**
         * [getScribeInfo description] 查询订阅信息
         * @return {[type]} [description]
         */
        function getScribeInfo() {
            var params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'findSubscript',
                group_id: folder.id,
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                $scope.data.scribeInfo = data.content;
                $scope.selectGroup($scope.data.scribeInfo[0]);
                $scope.status.isPushMsg = data.isPushMsg;
            });
        }
        /**
         * [close description] 关闭弹框
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        initStatus();
        initData();
    },
]);
